<template>
  <div>
    <div class="bg">
      <Nav title="舆情监测" @getTime="getTime" @address="addressList"/>
      <!-- 第三行 -->
      <div style="text-align: right">
        <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" @click="futureWeek"
                   type="primary">过去一周
        </el-button>
        <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" @click="futureHelfYear"
                   type="primary">过去半年
        </el-button>
        <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" @click="futureYear"
                   type="primary">过去一年
        </el-button>
        <el-select @change="changePlace" v-model="selectedItem" :value-key="'id'" placeholder="请选择">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.label"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div style="height: 95%;">
        <div class="box-item-option">
          <div class="box-grid">
            <h5 style="margin-top: 10px;"> 最新正面舆情</h5>
            <div class="new">
              <div v-for="(i,index) in positiveOpinion"
                   :key="index"
                   @click="details(i)"
                   style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                <div style="width: 70%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left"
                     class="backGround-line">
                  {{ i.title }}
                </div>
                <div style="display: flex;justify-content: center;align-items: center;width: 30%">
                  <div style="width: 60%;white-space: nowrap;" class="backGround-line">{{ i.publish_time }}</div>
                  <div v-if="i.index === true">已读</div>
                  <div class="backGround-line" v-else>未读</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-grid">
            <h5 style="margin-top: 10px;"> 最新负面舆情</h5>
            <div class="new">
              <div v-for="(i,index) in negativePublicity" :key="index" @click="details(i)"
                   style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                <div style="width: 60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left"
                     class="backGround-line">
                  {{ i.title }}
                </div>
                <div style="display: flex;justify-content: center;align-items: center;width: 30%">
                  <div style="width: 60%;white-space: nowrap;" class="backGround-line">{{ i.publish_time }}</div>
                  <div v-if="i.index === true">已读</div>
                  <div class="backGround-line" v-else>未读</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-grid">
            <h5 style="margin-top: 10px;"> 最新纸媒报道</h5>
            <div class="new">
              <div v-for="(i,index) in getLatestNews" :key="index" @click="details(i)"
                   style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                <div style="width: 70%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left"
                     class="backGround-line">
                  {{ i.title }}
                </div>
                <div style="display: flex;justify-content: center;align-items: center;width: 30%">
                  <div style="width: 60%;white-space: nowrap;" class="backGround-line">{{ i.publish_time }}</div>
                  <div v-if="i.index === true">已读</div>
                  <div class="backGround-line" v-else>未读</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-grid">
            <h5 style="margin-top: 10px;"> 最新游客评价</h5>
            <div class="new">
              <div v-for="(i,index) in getLatestTouristComments" :key="index" @click="details(i)"
                   style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                <div style="width: 70%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left"
                     class="backGround-line">
                  {{ i.content }}
                </div>
                <div style="display: flex;justify-content: center;align-items: center;width: 30%">
                  <div style="width: 60%;white-space: nowrap;" class="backGround-line">{{ i.cmt_time }}</div>
                  <div v-if="i.index === true">已读</div>
                  <div class="backGround-line" v-else>未读</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="map-box">
            <!-- 第一行两个图表 -->
            <div class="chart-box">
              <div
                  style="display: flex; justify-content: space-between; align-items: stretch; gap: 10px; margin-bottom: 10px;height: 100%;">
                <div style="flex: 1; background-color: transparent; color: white;height: 100%;">
                  <div class="backGround-line">信源占比图</div>
                  <div id="informationSource" style="width: 100%;height: 100%;"></div>
                </div>
                <div style="flex: 1; background-color: transparent; color: white;">
                  <div class="backGround-line">舆情风险</div>
                  <div id="OptionRiskIndex" style="width: 100%;height: 100%;"></div>
                </div>
                <div style="flex: 1; background-color: transparent; color: white;height: 100%;">
                  <div class="backGround-line">情绪占比图</div>
                  <div id="getemotionrate" style="width: 100%;height: 100%;"></div>
                </div>
              </div>
              <!-- 第二行两个图表 -->
              <!--              <div style="display: flex; justify-content: space-between; align-items: stretch; gap: 10px;height: 50%;">-->
              <!--                <div style="flex: 1; background-color: transparent; color: white;">-->
              <!--                  <div class="backGround-line">信源占比图</div>-->

              <!--                </div>-->
              <!--                <div style="flex: 1; background-color: transparent; color: white;">-->
              <!--                  <div class="backGround-line">舆情风险</div>-->

              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
          <!-- 右侧地图容器 -->
          <div class="map-box">
            <div style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;">
              <div style="height: 100%;width: 40%">
                <div class="backGround-line">热点话题</div>
                <div id="cloudWord" style="width: 100%;height: 90%;"></div>
              </div>
              <div style="height: 100%;width: 60%;">
                <div class="backGround-line">数据趋势</div>
                <div id="dataTrends" style="width: 100%; height: 100%; background-color: transparent;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--   每一条的详细数据 -->
    <div v-if="dialogVisible" class="mask">
      <div class="mask-content">
        <div style="text-align: right">
          <el-button style="border: none;background-color: transparent" icon="el-icon-close"
                     @click="dialogVisible=false"></el-button>
        </div>
        <div>
          <div>{{ pubicData.title }}</div>
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div>
              <i class="el-icon-link"></i>
              <a :href="pubicData.url" target="_blank">原文地址</a>
            </div>
            <div>来源:{{ pubicData.source }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "_c/Nav/Nav.vue"
import * as echarts from 'echarts';
import 'echarts-wordcloud'
import {
  publicOptionGetLatestUgcData,
  publicOptionGetSourceRate,
  publicOptionGetLatestNews,
  publicOptionGetLatestTouristComments,
  publicOptionGetPublicOptionRiskIndex,
  publicOptionGetPublicOptionDataTrend,
  datacenterGetemotionrate,
  datacenterGetheatedtopic
} from '@/request/tourismPublicOpiniocScreen/tourismPublicOpiniocScreen'
import {touristFlowGetPoiList} from '@/request/passengerFlow/passengerFlow.js'

export default {
  components: {
    Nav
  },
  data() {
    return {
      loading: '',
      getOption: ['最新正面舆情', '最新负面舆情', '最新纸媒报道', '最新游客评价'],
      selectedItem: null,
      poiId: '',  // 景区id
      valueCity: "",
      options: [], // 景点名称
      dataTime: {}, // 存储时间
      positiveOpinion: [],  // 正面舆情数据
      negativePublicity: [], // 负面舆情数据
      getLatestNews: [], // 最新纸媒报道数据
      getLatestTouristComments: [], // 最新游客评价
      dataInformationSource: [],// 信源占比图的数据
      dataCentergetSourcerate: null, // 情绪占比图
      dataCloudWord: [], // 词云图数据
      chart_1: null,   // 信源图的实列
      chart_2: null,   // 舆情风险实列
      chart_3: null, // 情绪占比图实列
      chart_4: null, // 数据趋势的实列
      chart_5: null, //词云图实列
      form: {       // 正负面数据的参数
        type: '',  // 1正面3负面
        limit: '20',
      },
      dialogVisible: false,//控制弹出框的
      pubicData: {} // 查看详情 的具体数据
    }
  },
  created() {
    // 景点名称
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    touristFlowGetPoiList().then(res => {
      this.options = res.data.data.map(item => ({
        id: item.id,
        value: item.id,
        label: item.name,
        lng: item.lng,
        lat: item.lat,
      }))
    })
    this.openFullScreen2()
    this.publicOptionGetLatestUgcData() //正负面舆情数据
    this.publicOptionGetLatestNews()  // 最新纸媒报道
    this.publicOptionGetLatestTouristComments()  // 最新游客评价

    this.$nextTick(async () => {
      await this.publicOptionGetSourceRate()  // 信源占比图
      await this.publicOptionGetPublicOptionRiskIndex() // 舆情指数
      await this.publicOptionGetPublicOptionDataTrend() // 数据趋势
      await this.datacenterGetemotionrate()  // 情绪占比图
      await this.datacenterGetheatedtopic()  // 词云图
      window.addEventListener('resize', this.handleResize);
      loading.close();

    })
  },
  methods: {
    // 默认的正负面舆情数据
    publicOptionGetLatestUgcData() {
      this.form.type = 1
      publicOptionGetLatestUgcData(this.form).then(res => {
        this.positiveOpinion = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      this.form.type = 3
      publicOptionGetLatestUgcData(this.form).then(res => {
        this.negativePublicity = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    // 默认的信源占比图
    publicOptionGetSourceRate() {
      publicOptionGetSourceRate().then((res) => {
        this.chart_1 = echarts.init(document.getElementById('informationSource'))
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })
    },
    // 默认最新纸媒报道
    publicOptionGetLatestNews() {
      publicOptionGetLatestNews({limit: 20}).then(res => {
        this.getLatestNews = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    //  默认最新游客评价
    publicOptionGetLatestTouristComments() {
      publicOptionGetLatestTouristComments({limit: 20}).then(res => {
        this.getLatestTouristComments = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    // 默认的舆情风险指数
    async publicOptionGetPublicOptionRiskIndex() {
      const res = await publicOptionGetPublicOptionRiskIndex()
      const {data} = res.data
      var demoData = [{
        name: '风险指数',
        unit: '%',
        value: data,
      },];
      this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
      const option = {
        backgroundColor: 'transparent',
        series: (function () {
          var result = [];
          demoData.forEach(function (item) {
            result.push(
                {
                  name: item.name,
                  type: 'gauge',
                  radius: '80%',
                  center: ['50%', '40%'],
                  startAngle: 225,
                  endAngle: -45,
                  min: 0,
                  max: 100,
                  axisLine: {
                    show: true,
                    lineStyle: {
                      width: 100,
                      color: [
                        [
                          item.value / 100, new echarts.graphic.LinearGradient(
                            0, 1, 1, 0, [{
                              offset: 0,
                              color: 'rgba(255, 36, 74,0)',
                            }, {
                              offset: 0.3,
                              color: 'rgba(255, 36, 74,0)',
                            },
                              {
                                offset: 1,
                                color: 'rgba(255, 36, 74,1)',
                              }
                            ]
                        )
                        ],
                        [
                          1, 'rgba(255,255,255,.0)'
                        ]
                      ]
                    }
                  },
                  axisTick: {
                    show: 0,
                  },
                  splitLine: {
                    show: 0,
                  },
                  axisLabel: {
                    show: 0
                  },
                  pointer: {
                    show: true,
                    length: '100%'
                  },
                  detail: {
                    show: true,
                    offsetCenter: [0, '100%'],
                    textStyle: {
                      fontSize: 16,
                      color: '#ff244a'
                    },
                    formatter: [
                      '{value}' + (item.unit || ''),
                      '{name|' + item.name + '}'
                    ].join('\n'),
                    rich: {
                      name: {
                        fontSize: 20,
                        lineHeight: 60,
                        color: '#fff',
                        fontWeight: '100',
                      }
                    }
                  },
                  itemStyle: {
                    color: 'rgba(255, 36, 74,.3)',
                    borderColor: 'rgba(255, 36, 74,1)',
                  },
                  data: [{
                    value: item.value
                  }]
                },
                {
                  name: item.name,
                  type: 'gauge',
                  radius: '80%',
                  center: ['50%', '40%'],

                  startAngle: 225,
                  endAngle: -45,
                  min: 0,
                  max: 100,
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: 0,
                  },
                  splitLine: {
                    show: 0,
                  },
                  axisLabel: {
                    show: 0
                  },
                  pointer: {
                    show: true,
                    width: 1,
                    length: '100%'
                  },
                  detail: {
                    show: false,
                  },
                  itemStyle: {
                    color: 'rgba(255, 36, 74,1)',
                  },
                  data: [{
                    value: item.value
                  }]
                },
                {
                  type: 'gauge',
                  radius: '80%',
                  center: ['50%', '40%'],
                  splitNumber: 10,
                  min: 0,
                  max: 100,
                  startAngle: 225,
                  endAngle: -45,
                  axisLine: {
                    show: true,
                    lineStyle: {
                      width: 3,
                      shadowBlur: 10,
                      color: [
                        [0, 'transparent'],
                        [0.1, '#0894f6'],
                        [0.11, 'transparent'],
                        [0.2, '#0894f6'],
                        [0.21, 'transparent'],
                        [0.3, '#0894f6'],
                        [0.31, 'transparent'],
                        [0.4, '#0894f6'],
                        [0.41, 'transparent'],
                        [0.5, '#0894f6'],
                        [0.51, 'transparent'],
                        [0.6, '#0894f6'],
                        [0.61, 'transparent'],
                        [0.7, '#0894f6'],
                        [0.71, 'transparent'],
                        [0.8, '#fd0001'],
                        [0.81, 'transparent'],
                        [0.9, '#fd0001'],
                        [0.91, 'transparent'],
                        [1, '#fd0001']
                      ]
                    }
                  },
                  axisLabel: {
                    formatter: function (e) {
                      switch (e + "") {
                        case "20":
                          return "较小";
                        case "80":
                          return "较大";
                        default:
                          return e;
                      }
                    },
                    textStyle: {
                      fontSize: 12,
                      fontWeight: ""
                    }
                  },
                  splitLine: {
                    length: 20,
                    lineStyle: {
                      color: 'auto'
                    }
                  },
                  axisTick: {
                    length: 10,
                    lineStyle: {
                      color: 'auto'
                    }
                  },
                  pointer: {
                    show: 0
                  },
                  detail: {
                    show: 0
                  }
                },);
          });

          return result;
        })()
      }
      this.chart_2.setOption(option)

    },
    // 默认的数据趋势
    async publicOptionGetPublicOptionDataTrend() {
      const res = await publicOptionGetPublicOptionDataTrend()
      this.chart_4 = echarts.init(document.getElementById('dataTrends'))
      const dataList1 = res.data.data.map(item => {
        return item.count
      })
      const dataList2 = res.data.data.map(item => {
        return item.risk
      })
      const dataTime = res.data.data.map(item => {
        return item.day
      })
      const option = {
        backgroundColor: 'transparent', // 暗色背景
        tooltip: {
          trigger: 'axis',
          axisPointer: {type: 'cross'} // 十字准星指示器
        },
        legend: {
          data: ['数据量', '舆情风险度'],
          textStyle: {  // 控制图例文字样式
            color: '#353bbc', // 修改为白色
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: dataTime,
          axisLine: {lineStyle: {color: '#666'}},
          axisLabel: {color: '#f4e2e5'}
        },
        yAxis: [
          {
            type: 'value',
            name: '数据量',
            position: 'left',
            axisLine: {
              lineStyle: {color: '#f4e2e5'}, // 左轴颜色
              show: true
            },
            splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
          },
          {
            type: 'value',
            name: '舆情风险度',
            position: 'right',
            axisLine: {
              lineStyle: {color: '#f4e2e5'}, // 右轴颜色
              show: true
            },
            splitLine: {show: false}, // 隐藏右轴网格线
            axisLabel: {
              formatter: '{value}%' // 显示百分比
            }
          }
        ],
        series: [
          {
            name: '数据量',
            type: 'line',
            data: dataList1,
            lineStyle: {width: 3, color: '#FFFFFF'},
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {color: '#FFFFFF'}
          },
          {
            name: '舆情风险度',
            type: 'line',
            yAxisIndex: 1, // 绑定到右Y轴
            data: dataList2, // 百分比数据（无需手动转换）
            lineStyle: {width: 3, color: '#33FFF6'},
            symbol: 'none', // 不显示数据点
            itemStyle: {color: '#33FFF6'},
            areaStyle: { // 填充区域
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                {offset: 1, color: 'rgba(88, 214, 141, 0)'}
              ])
            }
          }
        ]
      };
      this.chart_4.setOption(option);
    },
    // 默认的情绪占比图
    datacenterGetemotionrate() {
      this.chart_3 = echarts.init(document.getElementById('getemotionrate'))
      datacenterGetemotionrate().then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        // console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        // console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })
    },
    //默认的词云图
    datacenterGetheatedtopic() {
      this.chart_5 = echarts.init(document.getElementById('cloudWord'))
      datacenterGetheatedtopic().then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
    },
    // 看每一条数据的详情
    details(value) {
      this.dialogVisible = true;
      this.pubicData = value;

      // 获取本地存储中的 id 数组，如果没有则初始化为空数组
      let idArr = JSON.parse(localStorage.getItem('idArr') || '[]');

      // 检查是否已存在
      if (idArr.includes(value.id)) {
        console.log('已读');
      } else {
        // 不存在则添加到数组并更新本地存储
        idArr.push(value.id);
        localStorage.setItem('idArr', JSON.stringify(idArr));

        this.dataTime.type = 1
        publicOptionGetLatestUgcData(this.dataTime).then(res => {
          this.positiveOpinion = res.data.data
          const id = localStorage.getItem('idArr')
          for (let i = 0; i < res.data.data.length; i++) {
            if (id.includes(res.data.data[i].id)) {
              res.data.data[i].index = true
            }
          }
        })
        this.dataTime.type = 3
        publicOptionGetLatestUgcData(this.dataTime).then(res => {
          this.negativePublicity = res.data.data
          const id = localStorage.getItem('idArr')
          for (let i = 0; i < res.data.data.length; i++) {
            if (id.includes(res.data.data[i].id)) {
              res.data.data[i].index = true
            }
          }
        })
        publicOptionGetLatestNews(this.dataTime).then(res => {
          this.getLatestNews = res.data.data
          const id = localStorage.getItem('idArr')
          for (let i = 0; i < res.data.data.length; i++) {
            if (id.includes(res.data.data[i].id)) {
              res.data.data[i].index = true
            }
          }
        })
        publicOptionGetLatestTouristComments(this.dataTime).then(res => {
          this.getLatestTouristComments = res.data.data
          const id = localStorage.getItem('idArr')
          for (let i = 0; i < res.data.data.length; i++) {
            if (id.includes(res.data.data[i].id)) {
              res.data.data[i].index = true
            }
          }
        })
      }

    },
    // 选择时间后触发视图数据更新
    async getTime(value) {
      this.dataTime = {
        startTime: value[0],
        endTime: value[1],
        poiId: this.poiId
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 选择时间后触发信源占比图
      await publicOptionGetSourceRate(this.dataTime).then((res) => {
        // console.log(res)
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })

      // 选择时间后触发最新纸媒报道
      await publicOptionGetLatestNews(this.dataTime).then((res) => {
        this.getLatestNews = res.data.data
      })

      // 选择时间后触发新的舆情风险指数
      await publicOptionGetPublicOptionRiskIndex(this.dataTime).then((res) => {
        const {data} = res.data
        var demoData = [{
          name: '风险指数',
          unit: '%',
          value: data,
        },];
        this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
        const option = {
          backgroundColor: 'transparent',
          series: (function () {
            var result = [];

            demoData.forEach(function (item) {
              result.push(
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 100,
                        color: [
                          [
                            item.value / 100, new echarts.graphic.LinearGradient(
                              0, 1, 1, 0, [{
                                offset: 0,
                                color: 'rgba(255, 36, 74,0)',
                              }, {
                                offset: 0.3,
                                color: 'rgba(255, 36, 74,0)',
                              },
                                {
                                  offset: 1,
                                  color: 'rgba(255, 36, 74,1)',
                                }
                              ]
                          )
                          ],
                          [
                            1, 'rgba(255,255,255,.0)'
                          ]
                        ]
                      }
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      length: '100%'
                    },
                    detail: {
                      show: true,
                      offsetCenter: [0, '100%'],
                      textStyle: {
                        fontSize: 16,
                        color: '#ff244a'
                      },
                      formatter: [
                        '{value}' + (item.unit || ''),
                        '{name|' + item.name + '}'
                      ].join('\n'),
                      rich: {
                        name: {
                          fontSize: 20,
                          lineHeight: 60,
                          color: '#fff',
                          fontWeight: '100',
                        }
                      }
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,.3)',
                      borderColor: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],

                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      width: 1,
                      length: '100%'
                    },
                    detail: {
                      show: false,
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    splitNumber: 10,
                    min: 0,
                    max: 100,
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 3,
                        shadowBlur: 10,
                        color: [
                          [0, 'transparent'],
                          [0.1, '#0894f6'],
                          [0.11, 'transparent'],
                          [0.2, '#0894f6'],
                          [0.21, 'transparent'],
                          [0.3, '#0894f6'],
                          [0.31, 'transparent'],
                          [0.4, '#0894f6'],
                          [0.41, 'transparent'],
                          [0.5, '#0894f6'],
                          [0.51, 'transparent'],
                          [0.6, '#0894f6'],
                          [0.61, 'transparent'],
                          [0.7, '#0894f6'],
                          [0.71, 'transparent'],
                          [0.8, '#fd0001'],
                          [0.81, 'transparent'],
                          [0.9, '#fd0001'],
                          [0.91, 'transparent'],
                          [1, '#fd0001']
                        ]
                      }
                    },
                    axisLabel: {
                      formatter: function (e) {
                        switch (e + "") {
                          case "20":
                            return "较小";
                          case "80":
                            return "较大";
                          default:
                            return e;
                        }
                      },
                      textStyle: {
                        fontSize: 12,
                        fontWeight: ""
                      }
                    },
                    splitLine: {
                      length: 20,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    axisTick: {
                      length: 10,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    pointer: {
                      show: 0
                    },
                    detail: {
                      show: 0
                    }
                  },);
            });

            return result;
          })()
        }
        this.chart_2.setOption(option)
      })

      // 选择时间后触发新的数据趋势
      await publicOptionGetPublicOptionDataTrend(this.dataTime).then(res => {
        const dataList1 = res.data.data.map(item => {
          return item.count
        })
        const dataList2 = res.data.data.map(item => {
          return item.risk
        })
        const dataTime = res.data.data.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['数据量', '舆情风险度'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: '数据量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '舆情风险度',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: '数据量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '舆情风险度',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_4.setOption(option);
      })

      // 选择时间后触发新的情绪占比图
      await datacenterGetemotionrate(this.dataTime).then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })

      //  选择时间后 词云图数据改变
      await datacenterGetheatedtopic(this.dataTime).then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发正负面舆情
      const form = this.dataTime
      form.type = 1
      publicOptionGetLatestUgcData(form).then(res => {
        this.positiveOpinion = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      form.type = 3
      publicOptionGetLatestUgcData(form).then(res => {
        this.negativePublicity = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      loading.close();
    },
    // 选择景点
    async changePlace(value) {
      console.log(value)
      this.poiId = value.id
      this.dataTime.poiId = value.id
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 选择时间后触发信源占比图
      await publicOptionGetSourceRate(this.dataTime).then((res) => {
        // console.log(res)
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })

      // 选择时间后触发最新纸媒报道
      await publicOptionGetLatestNews(this.dataTime).then((res) => {
        this.getLatestNews = res.data.data
      })

      // 选择时间后触发新的舆情风险指数
      await publicOptionGetPublicOptionRiskIndex(this.dataTime).then((res) => {
        const {data} = res.data
        var demoData = [{
          name: '风险指数',
          unit: '%',
          value: data,
        },];
        this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
        const option = {
          backgroundColor: 'transparent',
          series: (function () {
            var result = [];

            demoData.forEach(function (item) {
              result.push(
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 100,
                        color: [
                          [
                            item.value / 100, new echarts.graphic.LinearGradient(
                              0, 1, 1, 0, [{
                                offset: 0,
                                color: 'rgba(255, 36, 74,0)',
                              }, {
                                offset: 0.3,
                                color: 'rgba(255, 36, 74,0)',
                              },
                                {
                                  offset: 1,
                                  color: 'rgba(255, 36, 74,1)',
                                }
                              ]
                          )
                          ],
                          [
                            1, 'rgba(255,255,255,.0)'
                          ]
                        ]
                      }
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      length: '100%'
                    },
                    detail: {
                      show: true,
                      offsetCenter: [0, '100%'],
                      textStyle: {
                        fontSize: 16,
                        color: '#ff244a'
                      },
                      formatter: [
                        '{value}' + (item.unit || ''),
                        '{name|' + item.name + '}'
                      ].join('\n'),
                      rich: {
                        name: {
                          fontSize: 20,
                          lineHeight: 60,
                          color: '#fff',
                          fontWeight: '100',
                        }
                      }
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,.3)',
                      borderColor: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],

                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      width: 1,
                      length: '100%'
                    },
                    detail: {
                      show: false,
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    splitNumber: 10,
                    min: 0,
                    max: 100,
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 3,
                        shadowBlur: 10,
                        color: [
                          [0, 'transparent'],
                          [0.1, '#0894f6'],
                          [0.11, 'transparent'],
                          [0.2, '#0894f6'],
                          [0.21, 'transparent'],
                          [0.3, '#0894f6'],
                          [0.31, 'transparent'],
                          [0.4, '#0894f6'],
                          [0.41, 'transparent'],
                          [0.5, '#0894f6'],
                          [0.51, 'transparent'],
                          [0.6, '#0894f6'],
                          [0.61, 'transparent'],
                          [0.7, '#0894f6'],
                          [0.71, 'transparent'],
                          [0.8, '#fd0001'],
                          [0.81, 'transparent'],
                          [0.9, '#fd0001'],
                          [0.91, 'transparent'],
                          [1, '#fd0001']
                        ]
                      }
                    },
                    axisLabel: {
                      formatter: function (e) {
                        switch (e + "") {
                          case "20":
                            return "较小";
                          case "80":
                            return "较大";
                          default:
                            return e;
                        }
                      },
                      textStyle: {
                        fontSize: 12,
                        fontWeight: ""
                      }
                    },
                    splitLine: {
                      length: 20,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    axisTick: {
                      length: 10,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    pointer: {
                      show: 0
                    },
                    detail: {
                      show: 0
                    }
                  },);
            });

            return result;
          })()
        }
        this.chart_2.setOption(option)
      })

      // 选择时间后触发新的数据趋势
      await publicOptionGetPublicOptionDataTrend(this.dataTime).then(res => {
        const dataList1 = res.data.data.map(item => {
          return item.count
        })
        const dataList2 = res.data.data.map(item => {
          return item.risk
        })
        const dataTime = res.data.data.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['数据量', '舆情风险度'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: '数据量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '舆情风险度',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: '数据量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '舆情风险度',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_4.setOption(option);
      })

      // 选择时间后触发新的情绪占比图
      await datacenterGetemotionrate(this.dataTime).then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })

      //  选择时间后 词云图数据改变
      await datacenterGetheatedtopic(this.dataTime).then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发正负面舆情
      const form = this.dataTime
      form.type = 1
      await publicOptionGetLatestUgcData(form).then(res => {
        this.positiveOpinion = res.data.data
      })
      form.type = 3
      await publicOptionGetLatestUgcData(form).then(res => {
        this.negativePublicity = res.data.data
      })
      loading.close();
    },
    // 过去一周
    futureWeek() {
      const today = new Date();
      const firstDay = new Date(today);
      firstDay.setDate(today.getDate() - 6); // 6天前
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.dataTime = {
        startTime: formatDate(firstDay),
        endTime: formatDate(today),
        poiId: this.poiId
      }
      // 选择时间后触发信源占比图
      publicOptionGetSourceRate(this.dataTime).then((res) => {
        // console.log(res)
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })

      // 选择时间后触发最新纸媒报道
      publicOptionGetLatestNews(this.dataTime).then((res) => {
        this.getLatestNews = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })


      //  默认最新游客评价
      publicOptionGetLatestTouristComments(this.dataTime).then(res => {
        this.getLatestTouristComments = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })

      // 选择时间后触发新的舆情风险指数
      publicOptionGetPublicOptionRiskIndex(this.dataTime).then((res) => {
        const {data} = res.data
        var demoData = [{
          name: '风险指数',
          unit: '%',
          value: data,
        },];
        this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
        const option = {
          backgroundColor: 'transparent',
          series: (function () {
            var result = [];

            demoData.forEach(function (item) {
              result.push(
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 100,
                        color: [
                          [
                            item.value / 100, new echarts.graphic.LinearGradient(
                              0, 1, 1, 0, [{
                                offset: 0,
                                color: 'rgba(255, 36, 74,0)',
                              }, {
                                offset: 0.3,
                                color: 'rgba(255, 36, 74,0)',
                              },
                                {
                                  offset: 1,
                                  color: 'rgba(255, 36, 74,1)',
                                }
                              ]
                          )
                          ],
                          [
                            1, 'rgba(255,255,255,.0)'
                          ]
                        ]
                      }
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      length: '100%'
                    },
                    detail: {
                      show: true,
                      offsetCenter: [0, '100%'],
                      textStyle: {
                        fontSize: 16,
                        color: '#ff244a'
                      },
                      formatter: [
                        '{value}' + (item.unit || ''),
                        '{name|' + item.name + '}'
                      ].join('\n'),
                      rich: {
                        name: {
                          fontSize: 20,
                          lineHeight: 60,
                          color: '#fff',
                          fontWeight: '100',
                        }
                      }
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,.3)',
                      borderColor: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],

                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      width: 1,
                      length: '100%'
                    },
                    detail: {
                      show: false,
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    splitNumber: 10,
                    min: 0,
                    max: 100,
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 3,
                        shadowBlur: 10,
                        color: [
                          [0, 'transparent'],
                          [0.1, '#0894f6'],
                          [0.11, 'transparent'],
                          [0.2, '#0894f6'],
                          [0.21, 'transparent'],
                          [0.3, '#0894f6'],
                          [0.31, 'transparent'],
                          [0.4, '#0894f6'],
                          [0.41, 'transparent'],
                          [0.5, '#0894f6'],
                          [0.51, 'transparent'],
                          [0.6, '#0894f6'],
                          [0.61, 'transparent'],
                          [0.7, '#0894f6'],
                          [0.71, 'transparent'],
                          [0.8, '#fd0001'],
                          [0.81, 'transparent'],
                          [0.9, '#fd0001'],
                          [0.91, 'transparent'],
                          [1, '#fd0001']
                        ]
                      }
                    },
                    axisLabel: {
                      formatter: function (e) {
                        switch (e + "") {
                          case "20":
                            return "较小";
                          case "80":
                            return "较大";
                          default:
                            return e;
                        }
                      },
                      textStyle: {
                        fontSize: 12,
                        fontWeight: ""
                      }
                    },
                    splitLine: {
                      length: 20,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    axisTick: {
                      length: 10,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    pointer: {
                      show: 0
                    },
                    detail: {
                      show: 0
                    }
                  },);
            });

            return result;
          })()
        }
        this.chart_2.setOption(option)
      })

      // 选择时间后触发新的数据趋势
      publicOptionGetPublicOptionDataTrend(this.dataTime).then(res => {
        const dataList1 = res.data.data.map(item => {
          return item.count
        })
        const dataList2 = res.data.data.map(item => {
          return item.risk
        })
        const dataTime = res.data.data.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['数据量', '舆情风险度'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: '数据量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '舆情风险度',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: '数据量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '舆情风险度',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_4.setOption(option);
      })

      // 选择时间后触发新的情绪占比图
      datacenterGetemotionrate(this.dataTime).then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })

      //  选择时间后 词云图数据改变
      datacenterGetheatedtopic(this.dataTime).then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发正负面舆情
       this.dataTime.type=1
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.positiveOpinion = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      this.dataTime.type= 3
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.negativePublicity = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    // 过去半年
    futureHelfYear() {
      function getHalfYearAgo(format = 'yyyy-mm-dd') {
        const date = new Date();
        date.setMonth(date.getMonth() - 6);
        // 处理跨年情况
        if (date.getMonth() > new Date().getMonth()) {
          date.setFullYear(date.getFullYear() - 1);
        }
        // 格式化函数
        const pad = num => String(num).padStart(2, '0');
        switch (format) {
          case 'yyyy-mm-dd':
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
          case 'dd/mm/yyyy':
            return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
          case 'timestamp':
            return date.getTime();
          default:
            return date;
        }
      }

      const time = getHalfYearAgo()
      const today = new Date();
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.dataTime = {
        startTime: time,
        endTime: formatDate(today),
        poiId: this.poiId
      }
      // 选择时间后触发信源占比图
      publicOptionGetSourceRate(this.dataTime).then((res) => {
        // console.log(res)
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })

      // 选择时间后触发最新纸媒报道
      publicOptionGetLatestNews(this.dataTime).then((res) => {
        this.getLatestNews = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })

      //  默认最新游客评价
      publicOptionGetLatestTouristComments(this.dataTime).then(res => {
        this.getLatestTouristComments = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })

      // 选择时间后触发新的舆情风险指数
      publicOptionGetPublicOptionRiskIndex(this.dataTime).then((res) => {
        const {data} = res.data
        var demoData = [{
          name: '风险指数',
          unit: '%',
          value: data,
        },];
        this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
        const option = {
          backgroundColor: 'transparent',
          series: (function () {
            var result = [];

            demoData.forEach(function (item) {
              result.push(
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 100,
                        color: [
                          [
                            item.value / 100, new echarts.graphic.LinearGradient(
                              0, 1, 1, 0, [{
                                offset: 0,
                                color: 'rgba(255, 36, 74,0)',
                              }, {
                                offset: 0.3,
                                color: 'rgba(255, 36, 74,0)',
                              },
                                {
                                  offset: 1,
                                  color: 'rgba(255, 36, 74,1)',
                                }
                              ]
                          )
                          ],
                          [
                            1, 'rgba(255,255,255,.0)'
                          ]
                        ]
                      }
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      length: '100%'
                    },
                    detail: {
                      show: true,
                      offsetCenter: [0, '100%'],
                      textStyle: {
                        fontSize: 16,
                        color: '#ff244a'
                      },
                      formatter: [
                        '{value}' + (item.unit || ''),
                        '{name|' + item.name + '}'
                      ].join('\n'),
                      rich: {
                        name: {
                          fontSize: 20,
                          lineHeight: 60,
                          color: '#fff',
                          fontWeight: '100',
                        }
                      }
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,.3)',
                      borderColor: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],

                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      width: 1,
                      length: '100%'
                    },
                    detail: {
                      show: false,
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    splitNumber: 10,
                    min: 0,
                    max: 100,
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 3,
                        shadowBlur: 10,
                        color: [
                          [0, 'transparent'],
                          [0.1, '#0894f6'],
                          [0.11, 'transparent'],
                          [0.2, '#0894f6'],
                          [0.21, 'transparent'],
                          [0.3, '#0894f6'],
                          [0.31, 'transparent'],
                          [0.4, '#0894f6'],
                          [0.41, 'transparent'],
                          [0.5, '#0894f6'],
                          [0.51, 'transparent'],
                          [0.6, '#0894f6'],
                          [0.61, 'transparent'],
                          [0.7, '#0894f6'],
                          [0.71, 'transparent'],
                          [0.8, '#fd0001'],
                          [0.81, 'transparent'],
                          [0.9, '#fd0001'],
                          [0.91, 'transparent'],
                          [1, '#fd0001']
                        ]
                      }
                    },
                    axisLabel: {
                      formatter: function (e) {
                        switch (e + "") {
                          case "20":
                            return "较小";
                          case "80":
                            return "较大";
                          default:
                            return e;
                        }
                      },
                      textStyle: {
                        fontSize: 12,
                        fontWeight: ""
                      }
                    },
                    splitLine: {
                      length: 20,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    axisTick: {
                      length: 10,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    pointer: {
                      show: 0
                    },
                    detail: {
                      show: 0
                    }
                  },);
            });

            return result;
          })()
        }
        this.chart_2.setOption(option)
      })

      // 选择时间后触发新的数据趋势
      publicOptionGetPublicOptionDataTrend(this.dataTime).then(res => {
        const dataList1 = res.data.data.map(item => {
          return item.count
        })
        const dataList2 = res.data.data.map(item => {
          return item.risk
        })
        const dataTime = res.data.data.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['数据量', '舆情风险度'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: '数据量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '舆情风险度',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: '数据量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '舆情风险度',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_4.setOption(option);
      })

      // 选择时间后触发新的情绪占比图
      datacenterGetemotionrate(this.dataTime).then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })

      //  选择时间后 词云图数据改变
      datacenterGetheatedtopic(this.dataTime).then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发正负面舆情
      this.dataTime.type=1
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.positiveOpinion = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      this.dataTime.type= 3
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.negativePublicity = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    // 过去一年
    futureYear() {
      function getLastYearRange() {
        const today = new Date();
        const lastYearSameDay = new Date(today);
        lastYearSameDay.setFullYear(today.getFullYear() - 1);

        // 格式化为 yyyy-mm-dd
        function formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }

        return {
          start: formatDate(lastYearSameDay),
          end: formatDate(today)
        };
      }

      const lastYearRange = getLastYearRange();
      this.dataTime = {
        startTime: lastYearRange.start,
        endTime: lastYearRange.end,
        poiId: this.poiId
      }

      // 选择时间后触发信源占比图
      publicOptionGetSourceRate(this.dataTime).then((res) => {
        // console.log(res)
        this.dataInformationSource = res.data.data
        var data = this.dataInformationSource.map((item) => ({
          name: item.name,
          value: item.percent
        }))
        this.chart_1.setOption({
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        })
      })

      // 选择时间后触发最新纸媒报道
      publicOptionGetLatestNews(this.dataTime).then((res) => {
        this.getLatestNews = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })

      //  默认最新游客评价
      publicOptionGetLatestTouristComments(this.dataTime).then(res => {
        this.getLatestTouristComments = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })

      // 选择时间后触发新的舆情风险指数
      publicOptionGetPublicOptionRiskIndex(this.dataTime).then((res) => {
        const {data} = res.data
        var demoData = [{
          name: '风险指数',
          unit: '%',
          value: data,
        },];
        this.chart_2 = echarts.init(document.getElementById('OptionRiskIndex'))
        const option = {
          backgroundColor: 'transparent',
          series: (function () {
            var result = [];

            demoData.forEach(function (item) {
              result.push(
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 100,
                        color: [
                          [
                            item.value / 100, new echarts.graphic.LinearGradient(
                              0, 1, 1, 0, [{
                                offset: 0,
                                color: 'rgba(255, 36, 74,0)',
                              }, {
                                offset: 0.3,
                                color: 'rgba(255, 36, 74,0)',
                              },
                                {
                                  offset: 1,
                                  color: 'rgba(255, 36, 74,1)',
                                }
                              ]
                          )
                          ],
                          [
                            1, 'rgba(255,255,255,.0)'
                          ]
                        ]
                      }
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      length: '100%'
                    },
                    detail: {
                      show: true,
                      offsetCenter: [0, '100%'],
                      textStyle: {
                        fontSize: 16,
                        color: '#ff244a'
                      },
                      formatter: [
                        '{value}' + (item.unit || ''),
                        '{name|' + item.name + '}'
                      ].join('\n'),
                      rich: {
                        name: {
                          fontSize: 20,
                          lineHeight: 60,
                          color: '#fff',
                          fontWeight: '100',
                        }
                      }
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,.3)',
                      borderColor: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    name: item.name,
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],

                    startAngle: 225,
                    endAngle: -45,
                    min: 0,
                    max: 100,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: 0,
                    },
                    splitLine: {
                      show: 0,
                    },
                    axisLabel: {
                      show: 0
                    },
                    pointer: {
                      show: true,
                      width: 1,
                      length: '100%'
                    },
                    detail: {
                      show: false,
                    },
                    itemStyle: {
                      color: 'rgba(255, 36, 74,1)',
                    },
                    data: [{
                      value: item.value
                    }]
                  },
                  {
                    type: 'gauge',
                    radius: '80%',
                    center: ['50%', '40%'],
                    splitNumber: 10,
                    min: 0,
                    max: 100,
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        width: 3,
                        shadowBlur: 10,
                        color: [
                          [0, 'transparent'],
                          [0.1, '#0894f6'],
                          [0.11, 'transparent'],
                          [0.2, '#0894f6'],
                          [0.21, 'transparent'],
                          [0.3, '#0894f6'],
                          [0.31, 'transparent'],
                          [0.4, '#0894f6'],
                          [0.41, 'transparent'],
                          [0.5, '#0894f6'],
                          [0.51, 'transparent'],
                          [0.6, '#0894f6'],
                          [0.61, 'transparent'],
                          [0.7, '#0894f6'],
                          [0.71, 'transparent'],
                          [0.8, '#fd0001'],
                          [0.81, 'transparent'],
                          [0.9, '#fd0001'],
                          [0.91, 'transparent'],
                          [1, '#fd0001']
                        ]
                      }
                    },
                    axisLabel: {
                      formatter: function (e) {
                        switch (e + "") {
                          case "20":
                            return "较小";
                          case "80":
                            return "较大";
                          default:
                            return e;
                        }
                      },
                      textStyle: {
                        fontSize: 12,
                        fontWeight: ""
                      }
                    },
                    splitLine: {
                      length: 20,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    axisTick: {
                      length: 10,
                      lineStyle: {
                        color: 'auto'
                      }
                    },
                    pointer: {
                      show: 0
                    },
                    detail: {
                      show: 0
                    }
                  },);
            });

            return result;
          })()
        }
        this.chart_2.setOption(option)
      })

      // 选择时间后触发新的数据趋势
      publicOptionGetPublicOptionDataTrend(this.dataTime).then(res => {
        const dataList1 = res.data.data.map(item => {
          return item.count
        })
        const dataList2 = res.data.data.map(item => {
          return item.risk
        })
        const dataTime = res.data.data.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['数据量', '舆情风险度'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: '数据量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '舆情风险度',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: '数据量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '舆情风险度',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_4.setOption(option);
      })

      // 选择时间后触发新的情绪占比图
      datacenterGetemotionrate(this.dataTime).then(res => {
        this.dataCentergetSourcerate = res.data.data   // 替换信源占比图数据
        console.log(res)
        const option = {
          colors: [
            "#FF5733",
            "#33FF57",
            "#3357FF",
            "#FF33A1",
            "#9033FF",
            "#33FFF6",
            "#FFBD33",
            "#FF3333",
            "#FFFFFF"
          ],
          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "38%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: [],
            },
          ],
        }
        const arrList = []
        for (let i = 0; i < this.dataCentergetSourcerate.name.length; i++) {
          arrList.push({
            name: this.dataCentergetSourcerate.name[i],
            value: this.dataCentergetSourcerate.value[i],
          })
        }
        console.log(arrList)
        option.series[0].data = arrList
        this.chart_3.setOption(option)
      })

      //  选择时间后 词云图数据改变
        datacenterGetheatedtopic(this.dataTime).then(res => {
        this.dataCloudWord = res.data.data.map((item) => ({
          "name": item.keyword,
          "value": item.count
        }))
        const data = this.dataCloudWord
        this.chart_5.setOption({
          grid: {
            top: '0%',    // 上边距
            right: '0%',   // 右边距
            bottom: '20%', // 下边距
            left: '0%',    // 左边距
          },
          series: [
            {
              type: "wordCloud",
              // 网格大小，各项之间间距
              gridSize: 12,
              // 形状 circle 圆，cardioid  心， diamond 菱形，
              // triangle-forward 、triangle 三角，star五角星
              shape: 'circle',
              // 字体大小范围
              sizeRange: [12, 20],
              // 文字旋转角度范围
              rotationRange: [0, 0],
              // 旋转步值
              rotationStep: 90,
              // 自定义图形
              // maskImage: maskImage,
              left: 'center',
              top: 'center',
              right: null,
              // 画布宽
              width: '90%',
              // 画布高
              height: '100%',
              // 是否渲染超出画布的文字
              drawOutOfBound: false,
              textStyle: {
                color: function () {
                  const colors = ['#165DFF', '#6aca37',
                    '#05a4b6', '#f93920', '#f0b114']
                  return colors[parseInt(Math.random() * (colors.length))];
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#2ac'
                }
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发正负面舆情
      this.dataTime.type=1
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.positiveOpinion = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
      this.dataTime.type= 3
      publicOptionGetLatestUgcData(this.dataTime).then(res => {
        this.negativePublicity = res.data.data
        const id = localStorage.getItem('idArr')
        for (let i = 0; i < res.data.data.length; i++) {
          if (id.includes(res.data.data[i].id)) {
            res.data.data[i].index = true
          }
        }
      })
    },
    addressList(value) {
      this.valueCity = value
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 1)'
      });
    },
    handleResize() {
      this.chart_1.resize()
      this.chart_2.resize()
      this.chart_3.resize()
      this.chart_4.resize()
      this.chart_5.resize()
    }
  },
  computed: {
    filterParams() {
      return {
        timeRange: this.valueTime,
        city: this.valueCity
      };
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {}
}
</script>
<style scoped lang="scss">
h5 {
  color: #b7b7e3;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  box-sizing: border-box;
  /* 关键修改：包含内边距到尺寸计算中 */
  overflow-y: hidden;
  /* 隐藏超出部分 */
}

/* 防止内部元素撑破 */
* {
  box-sizing: border-box;
}

.container {
  width: 100%;
  height: 45%;
  display: flex;
  justify-content: space-between;
  align-items: stretch; /* 关键点 */
  gap: 10px;
  margin-top: 20px;
}

.map-box {
  flex: 1;
  height: auto;
  //background-color: #111b27;
  background: rgb(12, 27, 39, 0.6);
  border-radius: 12px;
}

.chart-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.box-grid {
  //color: white;
  text-align: center;
  width: calc(25% - 7.5px); /* 减去间距，假设gap是10px，则每个元素需要减去3/4的间隙 */
  box-sizing: border-box;
  height: 100%;
  background-color: #111b27;
  margin-top: 10px;
  border-radius: 12px;
}

.new > div {
  border-bottom: 1px white dashed;
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
}

.new::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Edge 隐藏滚动条 */
}

.new {
  overflow: auto;
  white-space: nowrap;
  /* 防止换行 */
  height: calc(100% - 30px);
  -ms-overflow-style: none;
  /* IE 和 Edge 隐藏滚动条 */
  scrollbar-width: none;
  /* Firefox 隐藏滚动条 */
}


dv-border-box-10 {
  height: 100%;
  /* 确保子容器继承高度 */
  box-sizing: border-box;
}

.box-item-option {
  display: flex;
  justify-content: space-between;
  height: 35%;
  gap: 10px;
  width: 100%;
  color: white;
}

.mask-content {
  width: 30%;
  background-color: rgba(15, 19, 37, 0.95);
  padding: 15px;
  height: 30%;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  //color: #fff;
  min-width: 300px;
  position: relative;
}

.mask {
  position: fixed;
  text-shadow: 0 0 1px white; /* 这会导致白光圈 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.el-select {
  width: 200px; // 增大宽度
  font-size: 16px; // 增大字体
  background-color: transparent; // 半透明白色背景
  border-radius: 8px; // 圆角
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); // 阴影
  transition: all 0.3s ease;
  margin-left: 10px;
  color: black;

  ::v-deep.el-select .el-input__inner {
    //margin-left: 10px !important;
  }

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3); // 悬停阴影加强
  }

  :deep(.el-input__inner) {
    background-color: transparent; // 内部输入框透明
    border: none; // 移除默认边框
  }

  :deep(.el-select-dropdown__item) {
    color: black !important;
  }

  .el-select-dropdown {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .el-select-dropdown__item {
    font-size: 15px;
    padding: 10px 20px;
    color: black;

    &:hover {
      background-color: #e6f7ff; // 悬停颜色
    }
  }
}
</style>
